<template>
  <button
    v-tooltip.top="`Align Left`"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    @click="editor.chain().focus().setTextAlign('left').run()"
  >
    <Icon
      class="h-[20px] w-[20px]"
      name="material-symbols:format-align-left"
    />
  </button>

  <button
    v-tooltip.top="`Align Center`"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    @click="editor.chain().focus().setTextAlign('center').run()"
  >
    <Icon
      class="h-[20px] w-[20px]"
      name="material-symbols:format-align-center-rounded"
    />
  </button>

  <button
    v-tooltip.top="`Align Right`"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    @click="editor.chain().focus().setTextAlign('right').run()"
  >
    <Icon
      class="h-[20px] w-[20px]"
      name="material-symbols:format-align-right"
    />
  </button>
</template>

<script setup lang="ts">
const editor = defineModel('editor')
</script>
